import { GraphQL } from "@rpi/openapi-api";
import { getPageCountBounds } from "./productSpecification.util";

export { MIN_PAGE_COUNT } from "./productSpecification.util";

export type PriceInfo = {
  usd?: GraphQL.OpenapiProductPricing;
  minPageCount: number;
  maxPageCount: number;
  pageIncrement: number;
};

export function getBookPriceInfoUSD(
  openapiProduct?: GraphQL.OpenApiProductWithPricingQuery["openapiProduct"]
): PriceInfo {
  const { min, max, step } = getPageCountBounds(openapiProduct?.productSpecification?.specification);

  const usd = openapiProduct?.productPricing?.find(
    (productPrice) => productPrice.currency === GraphQL.SupportedCurrency.Usd
  );

  return { usd, minPageCount: min, maxPageCount: max, pageIncrement: step };
}
